__turbopack_context__.v({
  "centeredContent": "Zb5gmG_centeredContent",
  "content": "Zb5gmG_content",
  "loader": "Zb5gmG_loader",
  "loaderContainer": "Zb5gmG_loaderContainer",
  "loaderText": "Zb5gmG_loaderText",
  "mainContent": "Zb5gmG_mainContent",
  "pageLayout": "Zb5gmG_pageLayout",
  "primaryContent": "Zb5gmG_primaryContent",
  "sideBarContent": "Zb5gmG_sideBarContent",
});
